export enum ENTITIES {
  BUSINESS_ACTIVITY = 'BUSINESS_ACTIVITY',
  BUSINESS_PROCESS = 'BUSINESS_PROCESS',
  BUSINESS_UNIT = 'BUSINESS_UNIT',
  LOCATION = 'LOCATION',
  PLAN = 'PLAN',
  PLAN_ACTION = 'PLAN_ACTION',
  PLAN_KPI = 'PLAN_KPI',
  PLAN_OBJECTIVE = 'PLAN_OBJECTIVE',
  PLAN_TYPE = 'PLAN_TYPE',
  POSITION = 'POSITION',
  USER = 'USER',
  RISK = 'RISK'
}

export const ENTITIES_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE'
}
